// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aFDN","badges":"styles_badges__1mikD"};